import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { useShouldShowCommunityAiModal } from "@circle-react/hooks/useIsActivityScoreEnabled";
import classNames from "classnames";

import { useCommunityAiUpgradeModal } from "@/react/components/SettingsApp/CommunityAi/UpgradeModal";

const BASE_CLASSES =
  "inline-flex items-center justify-center gap-x-2 rounded-3xl border px-2.5 py-1.5";

const COMPASS_BASE_CLASSES =
  "inline-flex items-center justify-center gap-1 rounded-md border px-2 h-[22px]";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  useCompassStyles?: boolean;
}

export const Container = ({
  className,
  children,
  useCompassStyles = false,
}: ContainerProps) => {
  const shouldShowCommunityAiModal = useShouldShowCommunityAiModal();
  const communityAiModal = useCommunityAiUpgradeModal();

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await communityAiModal.show({
      source: UPGRADE_FLOW_SOURCES.ACTIVITY_SCORES_SCORE_CHIP,
    });
  };

  const commonProps = {
    className: classNames(
      useCompassStyles ? COMPASS_BASE_CLASSES : BASE_CLASSES,
      className,
    ),
    onClick: shouldShowCommunityAiModal ? handleClick : undefined,
  };

  if (shouldShowCommunityAiModal) {
    return (
      <button {...commonProps} type="button">
        {children}
      </button>
    );
  }
  return <div {...commonProps}>{children}</div>;
};
